import styles from './Navbar.module.css';
import { Link, useLocation } from 'react-router-dom';
import {
  APPLICATIONS,
  AUTH,
  CARDS,
  PAYMENTS,
  SETTINGS,
  WITHDRAWAL,
  MERCHANT_APPLICATIONS,
  MERCHANT_SETTLEMENTS,
  MERCHANT_DISPUTES,
} from '../../utils/constants/routes';
import { useVisible } from '../../utils/hooks/useVisible';

export const Navbar = () => {
  const location = useLocation();
  const { notVisible } = useVisible();

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('refresh_token');
  };

  if (notVisible) return null;
  return (
    <div className={styles.navBar}>
      <div className={styles.navbarInner}>
        <div className={styles.logo}>
          {' '}
          <img className={styles.logoImg} src='/logo.svg' alt='logo' />
        </div>


         <Link to={MERCHANT_SETTLEMENTS} className='link-style'>
          <div className={location.pathname === MERCHANT_SETTLEMENTS ? styles.activeButton : styles.button}>
            <img
              src={
                location.pathname === MERCHANT_SETTLEMENTS
                  ? '/wallet.svg'
                  : '/wallet.svg'
              }
              alt={'application'}
            />{' '}
            Кошелек
          </div>
        </Link>

        <Link to={MERCHANT_APPLICATIONS} className='link-style'>
          <div className={location.pathname === MERCHANT_APPLICATIONS ? styles.activeButton : styles.button}>
            <img
              src={
                location.pathname === MERCHANT_APPLICATIONS
                  ? '/history.svg'
                  : '/history.svg'
              }
              alt={'application'}
            />{' '}
            Заявки
          </div>
        </Link>

        <Link to={MERCHANT_DISPUTES} className='link-style'>
          <div className={location.pathname === MERCHANT_DISPUTES ? styles.activeButton : styles.button}>
            <img
              src={
                location.pathname === MERCHANT_DISPUTES
                  ? '/dispute.svg'
                  : '/dispute.svg'
              }
              alt={'application'}
            />{' '}
            Споры
          </div>
        </Link>

        <Link to={AUTH} className='link-style'>
          <div className={styles.button} style={{ color: '#FE5B37' }} onClick={logout}>
            <img src={'/logout_icon.png'} alt={'logout_icon'} /> Выход
          </div>
        </Link>
      </div>
    </div>
  );
};
